export default __webpack_public_path__ + "static/allison-0f7823df9011158b34565adb1dfe513d.jpg";